import { Radio as MuiRadio, RadioProps, SvgIcon } from '@mui/material'

export const RadioIcon = () => (
  <SvgIcon>
    <circle cx="12" cy="12" r="12" fill="#313AAC" fillOpacity="0.12" />
  </SvgIcon>
)

export const RadioCheckedIcon = () => (
  <SvgIcon>
    <circle cx="12" cy="12" r="12" fill="#313AAC" fillOpacity="0.12" />
    <circle cx="12" cy="12" r="6" fill="currentColor" />
  </SvgIcon>
)

export const Radio = (props: RadioProps) => (
  <MuiRadio icon={<RadioIcon />} checkedIcon={<RadioCheckedIcon />} {...props} />
)
